import script from "./PresentMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./PresentMobile.vue?vue&type=script&setup=true&lang=js"

import "./PresentMobile.vue?vue&type=style&index=0&id=5889bf30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5889bf30"]])

export default __exports__